import request from '@/utils/request';
import React from 'react';

/**
 * 获取登录用户导航菜单
 */
export function getLoginMenu() {
  return request.get<API.Menu[]>('/api/menu');
}

/**
 * 获取菜单树
 */
export function getMenuTree(params?: {
  name?: string;
}) {
  let url = '/api/menu/tree';
  if (params?.name) {
    url = `${url}?name=${params.name}`;
  }
  return request.get<API.Menu[]>(url);
}

/**
 * 获取菜单详情
 * @param id
 */
export function getMenu(id: string) {
  return request.get<API.Menu>(`/api/menu/${id}`);
}

/**
 * 保存菜单实体
 * @param data
 */
export function saveMenu(data: API.Menu) {
  return request.post('/api/menu', data);
}

/**
 * 删除菜单实体
 * @param id
 */
export function deleteMenu(id: string) {
  return request.delete(`/api/menu/${id}`);
}

/**
 * 批量删除菜单实体
 * @param ids
 */
export function batchDeleteMenu(ids: React.Key[]) {
  return request.delete('/api/menu/batch', {
    data: {
      ids,
    },
  });
}
